import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardBody from 'components/Card/CardBody';
import CardFooter from 'components/Card/CardFooter';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/permissionExpirePageStyle';
import { dispatch } from 'redux/store';
import { hideLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { BodyM, BodyS } from 'components/Typography/Typography';
import { AuthConsumer } from 'components/Auth/authContext';
import Button from 'components/CustomButtons/Button';

// @ts-ignore
const useStyles = makeStyles(styles);

export default function PermissionExpiredPage() {
	const classes = useStyles();

	// Hide any running indicators
	useEffect(() => {
		dispatch(hideLoadingIndicator());
	}, []);

	return (
		<>
			<CardBody className={classes.cardBody}>
				<BodyM color="primary-light">{translate('permission-expired.description1')}</BodyM>
				<BodyM color="primary-light">{translate('permission-expired.description2')}</BodyM>
			</CardBody>
			<CardFooter className={classes.justifyContentCenter}>
				<AuthConsumer>
					{({ logout }) => (
						<div>
							<Button onClick={logout} color="tertiary-light" type="bodyMBold">
								{translate('forgot.backLogin')}
							</Button>
							<div className={classes.footerLinks}>
								<BodyS color="secondary-light">{translate('copyright')}</BodyS>
							</div>
						</div>
					)}
				</AuthConsumer>
			</CardFooter>
		</>
	);
}
